var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("rect", { width: "40", height: "40", fill: "#E1F7F7", rx: "8" }),
      React.createElement("path", { d: "M8 8h24v24H8z" }),
      React.createElement("path", { fill: "#018489", d: "M29.155 19.94a1.01 1.01 0 0 0 .998-.998l.038-3.95a.97.97 0 0 0-.978-.978l-3.952.037a1.011 1.011 0 0 0-.997.997.965.965 0 0 0 .978.978l1.543-.015-6.582 6.49-3.233-2.821a.99.99 0 0 0-1.35.058l-4.986 4.986a.988.988 0 0 0-.013 1.397.988.988 0 0 0 1.396-.014l4.327-4.326 3.228 2.817a.99.99 0 0 0 1.345-.053l7.276-7.174-.016 1.59a.965.965 0 0 0 .979.978z" })
    )
  );
});